export const selectCache = (state) => state.users.userCache
export const selectPosts = (state) => state.posts.posts
